import { ComponentStyleConfig } from '@chakra-ui/react';

export const SelectionCard: ComponentStyleConfig = {
  parts: ['container', 'icon'],
  baseStyle: {
    container: {
      width: 273,
      margin: 0,
      flexDirection: 'column',
      cursor: 'pointer',
      transitionTimingFunction: 'ease-in-out',
      transitionDuration: '300ms',
      transitionProperty: 'box-shadow, border-color',
      boxShadow: 'none',
      '&:hover:not(:disabled)': {
        transform: 'scale(1.02)',
      },
      '&:active:not(:disabled)': {
        transform: 'scale(0.97)',
        shadow: 'pressed',
      },
    },
    header: {
      bg: 'M.30',
      py: '28px',
      px: 4,
      mb: 2,
      rounded: 4,
    },
    icon: {
      width: '56px',
      height: '56px',
      bg: 'surface2',
      color: 'M.70',
      rounded: 4,
      mb: 2,
      '& svg': {
        width: '35px',
        height: '35px',
      },
    },
  },
};
